<h2 mat-dialog-title>Confirmer le désabonnement</h2>
<div mat-dialog-content>
  <p>Êtes-vous sûr de vouloir vous désabonner de cet utilisateur ?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="warn" (click)="confirmUnfollow()">Se désabonner</button>
</div>
